module.exports = function( $scope, $ ) {
	$scope.find( '.kitbuilder-alert-dismiss' ).on( 'click', function() {
		$( this ).parent().fadeOut();
	} );
};
